import React from "react";
import { RightPanel } from "../../../components/RightPanel";
import { ManageLead } from "../ManageLead";
import { MODULES_UUIDS } from "../../../constants/enums";
import { ILead } from "../../../redux/leads/leads.types";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { OpenInFull } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { REACT_APP_NAV_ROUTES } from "../../../router/AppNavigation";

interface IQuickEditLeadProps {
  open: boolean;
  onClose: () => void;
  leadDetails: ILead;
}

const QuickEditLead: React.FC<IQuickEditLeadProps> = (props) => {
  const { open, onClose, leadDetails } = props;

  const navigate = useNavigate()
  return (
    <RightPanel
      width="95%"
      open={open}
      heading="Quick Edit Lead"
      onClose={onClose}
      topRightButtons={
        <Tooltip title="Full View" arrow>
          <span>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
                navigate(
                  `${REACT_APP_NAV_ROUTES.leads.EventLeads}/manage/${leadDetails.leads_uuid}/${leadDetails.multiple_events_uuid}`,
                );
              }}
              sx={{
                color: "#fff",
                border: "1px solid rgba(255,255,255,0.5)",
                borderRadius: 1,
                px: 1,
                py: 0.5,
                gap: 0.5,
                fontSize: "0.75rem",
                "&:hover": { bgcolor: "rgba(255,255,255,0.15)" },
              }}
            >
              <OpenInFull sx={{ fontSize: "1rem" }} />
              <Typography variant="caption" color="#fff" sx={{ lineHeight: 1 }}>
                Full View
              </Typography>
            </IconButton>
          </span>
        </Tooltip>
      }
    >
      <ManageLead
        moduleUuid={MODULES_UUIDS.LEADS}
        compactModeLeadUUID={leadDetails.leads_uuid || undefined}
        compactModeLeadMeUUID={leadDetails.multiple_events_uuid || undefined}
        isEmbeddedView
        leadDetails={leadDetails}
      />
    </RightPanel>
  );
};

export default QuickEditLead;
